import moment from "moment";

var ApolloFilters = {
    simpleDate: function (value) {
        if (!value) {
            return "";
        }

        return moment(value).format("MM/DD/YYYY");
    },
    dateYYYYMMDD: function (value) {
        if (!value) {
            return "";
        }

        return moment(value).format("YYYY-MM-DD");
    },
    datePicker: function (d) {
        return d.toLocaleDateString()
    },
    calendarMonth: function (value) {
        if (!value) {
            return "";
        }

        return moment(value).format("MMM").toUpperCase();
    },
    calendarDay: function (value) {
        if (!value) {
            return "";
        }

        return moment(value).format("DD");
    },
    textDate: function (value) {
        if (!value) {
            return "";
        }

        return moment(value).format("MMMM Do, YYYY");
    },
    verboseTextDate: function (value) {
        if (!value) {
            return "";
        }

        return moment(value).format("dddd, MMMM Do, YYYY");
    },
    currency: function (v) {
        if (v == null) {
            return "";
        }

        return v.toLocaleString("en-US", { style: "currency", currency: "USD" })
    }
};

export default ApolloFilters;



// WEBPACK FOOTER //
// ./src/models/ApolloFilters.js